/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 erp返回资金流水 的 **请求配置**
 *
 * @分类 爆版4.23.0
 * @请求头 `POST /erp/RefundBill/index`
 */
const postIndexRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/RefundBill/index",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postIndex",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 erp返回资金流水 的 **请求函数**
 *
 * @分类 爆版4.23.0
 * @请求头 `POST /erp/RefundBill/index`
 */
export const postIndex = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postIndexRequestConfig, requestData), ...args);
};
postIndex.requestConfig = postIndexRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 发送短信 的 **请求配置**
 *
 * @分类 履约达标返佣发送短信
 * @请求头 `POST /erp/RefundBill/sendMsgSupply`
 */
const postSendMsgSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/RefundBill/sendMsgSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSendMsgSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 发送短信 的 **请求函数**
 *
 * @分类 履约达标返佣发送短信
 * @请求头 `POST /erp/RefundBill/sendMsgSupply`
 */
export const postSendMsgSupply = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSendMsgSupplyRequestConfig, requestData), ...args);
};
postSendMsgSupply.requestConfig = postSendMsgSupplyRequestConfig;
/**
 * 接口 获取需要发送短信供应商 的 **请求配置**
 *
 * @分类 履约达标返佣发送短信
 * @请求头 `POST /erp/RefundBill/getNeedSendMsgSupply`
 */
const postGetNeedSendMsgSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/RefundBill/getNeedSendMsgSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetNeedSendMsgSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取需要发送短信供应商 的 **请求函数**
 *
 * @分类 履约达标返佣发送短信
 * @请求头 `POST /erp/RefundBill/getNeedSendMsgSupply`
 */
export const postGetNeedSendMsgSupply = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetNeedSendMsgSupplyRequestConfig, requestData),
    ...args
  );
};
postGetNeedSendMsgSupply.requestConfig = postGetNeedSendMsgSupplyRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 导入返还单商家 的 **请求配置**
 *
 * @分类 #5185
 * @请求头 `POST /erp/RefundBill/importSupply`
 */
const postImportSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/RefundBill/importSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入返还单商家 的 **请求函数**
 *
 * @分类 #5185
 * @请求头 `POST /erp/RefundBill/importSupply`
 */
export const postImportSupply = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postImportSupplyRequestConfig, requestData), ...args);
};
postImportSupply.requestConfig = postImportSupplyRequestConfig;
/**
 * 接口 导出商家 的 **请求配置**
 *
 * @分类 #5185
 * @请求头 `POST /erp/RefundBill/exportSupply`
 */
const postExportSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/RefundBill/exportSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出商家 的 **请求函数**
 *
 * @分类 #5185
 * @请求头 `POST /erp/RefundBill/exportSupply`
 */
export const postExportSupply = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postExportSupplyRequestConfig, requestData), ...args);
};
postExportSupply.requestConfig = postExportSupplyRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/refundBill.js